export default __webpack_public_path__ + "static/media/wifi.d29187a2.png";